import React from "react";
import { Navigate } from "react-router-dom";
function ImpersonateCheck({ children }) {
  const token = localStorage.getItem("impersonateCheck");
  return token === "is-superadmin-imp" ? children : <Navigate to="/logout" />;
}

export default ImpersonateCheck;
